// ============================================================================
// Icon Map
// ----------------------------------------------------------------------------
// Content stores icons as string keys (CMS-friendly). The UI resolves those
// keys to lucide-react components through this single map.
// ============================================================================

import {
  Activity,
  BadgeCheck,
  Building2,
  ClipboardCheck,
  Compass,
  FileCheck2,
  FileSearch,
  FlaskConical,
  FolderArchive,
  Gauge,
  GraduationCap,
  Handshake,
  HeartPulse,
  Layers,
  LifeBuoy,
  MapPin,
  MessagesSquare,
  Rocket,
  ScrollText,
  ShieldCheck,
  Sparkles,
  Stethoscope,
  Target,
  UserPlus,
  Users,
  Workflow,
  type LucideIcon,
} from "lucide-react";

export const iconMap: Record<string, LucideIcon> = {
  "shield-check": ShieldCheck,
  "clipboard-check": ClipboardCheck,
  rocket: Rocket,
  users: Users,
  handshake: Handshake,
  "heart-pulse": HeartPulse,
  "folder-archive": FolderArchive,
  "file-check": FileCheck2,
  "file-search": FileSearch,
  "graduation-cap": GraduationCap,
  workflow: Workflow,
  "user-plus": UserPlus,
  building: Building2,
  gauge: Gauge,
  "scroll-text": ScrollText,
  activity: Activity,
  stethoscope: Stethoscope,
  flask: FlaskConical,
  "badge-check": BadgeCheck,
  target: Target,
  compass: Compass,
  sparkles: Sparkles,
  "map-pin": MapPin,
  layers: Layers,
  lifebuoy: LifeBuoy,
  message: MessagesSquare,
};

/** Safely resolve an icon key to a component, falling back to a neutral icon. */
export function getIcon(key: string): LucideIcon {
  return iconMap[key] ?? Sparkles;
}
